import { Layout } from 'react-admin';
import { MyMenu } from '../MyMenu/MyMenu';
import { MyAppBar } from '../MyAppBar/MyAppBar';
import {
    AppLocationContext,
    Breadcrumb,
    ResourceBreadcrumbItems,
} from "@react-admin/ra-navigation";
// import { ReactQueryDevtools } from 'react-query/devtools'


export const MyLayout = ({ children, ...props }) => (
    <AppLocationContext hasDashboard>
        <Layout {...props} menu={MyMenu} appBar={MyAppBar}>
            <Breadcrumb hasDashboard={true}>
                <ResourceBreadcrumbItems />
            </Breadcrumb>
            {children}
        </Layout>
    </AppLocationContext>
);

